import { render } from "./Success.vue?vue&type=template&id=d9b2ff82"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/share.filevaultcore.com/share.filevaultcore.com/share.filevaultcore.spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__